import React, { useEffect, useContext } from "react";
import { connect } from "react-redux";

import * as actions from "js/actions/actions";

import SiteHeader from "core/SiteHeader";

import { Login, Join } from "./ProfileMenu/styles";

import { authLinks } from "data/links";

import logOutAndRedirect from "helpers/log-out";

import { Context as BannerContext } from "frontend/context/BannersContext";
import { useCurrentUserContext } from "contexts/CurrentUserContext";

const LoginLinkUnwrapped = ({ redirect }) => {
    const toEncode = `${window.location.pathname}${window.location.search}`;
    const encodedUrl = encodeURIComponent(toEncode);

    const logIn = e => {
        e.preventDefault();
        redirect(`${authLinks.login.href}?next=${encodedUrl}`);
    };

    return (
        <Login
            data-test="login-link"
            href={authLinks.login.href}
            title={authLinks.login.text}
            onClick={logIn}
        >
            {authLinks.login.text}
        </Login>
    );
};

const LoginLink = connect(null, { redirect: actions.redirect })(
    LoginLinkUnwrapped
);

const JoinLinkUnwrapped = ({ redirect }) => {
    const toEncode = `${window.location.pathname}${window.location.search}`;
    const encodedUrl = encodeURIComponent(toEncode);

    const handleJoin = e => {
        e.preventDefault();
        redirect(`${authLinks.signup.href}?next=${encodedUrl}`);
    };

    return (
        <Join
            href={authLinks.signup.href}
            title={authLinks.signup.text}
            onClick={handleJoin}
        >
            {authLinks.signup.text}
        </Join>
    );
};

const JoinLink = connect(null, { redirect: actions.redirect })(
    JoinLinkUnwrapped
);

const NounProjectHeader = () => {
    const handleLogOut = () => {
        logOutAndRedirect();
    };

    const bannerContext = useContext(BannerContext);
    const { currentUser } = useCurrentUserContext();

    useEffect(() => {
        const rootWrapper = document.getElementById(
            "react-legacy-header-wrapper"
        );
        rootWrapper.style.height = "auto";
    }, []);

    // this code is also in SiteHeaderParent for non legacy pages
    const {
        hideBanner,
        bannerContent,
        bannerContentMobile,
        bannerKey,
        dismissBanner
    } = bannerContext;

    return (
        <>
            <SiteHeader
                hideBanner={hideBanner}
                dismissBanner={dismissBanner}
                bannerContent={bannerContent}
                bannerContentMobile={bannerContentMobile}
                bannerKey={bannerKey}
                currentUser={currentUser?.data?.currentUser ?? null}
                loading={currentUser?.loading}
                loginLinkLegacy={<LoginLink />}
                joinLinkLegacy={<JoinLink />}
                handleLogOut={handleLogOut}
            />
        </>
    );
};

export default NounProjectHeader;
